import { CurrencyOption } from 'types/enums/CurrencyOptions';
import { formatCurrency } from 'utils/formatCurrency';

// FIXME: Kept as a fixed value for mock demo, update to use live fx rates
export const USD_TO_CAD_EXCHANGE_RATE = 1.384;

// TODO: Clean up util funcs on this file, merge in duplicated logic, etc.

export function convertUsdForDisplay(
  usdAmount: number,
  currency: CurrencyOption
): number {
  if (currency === CurrencyOption.CAD) {
    return usdAmount * USD_TO_CAD_EXCHANGE_RATE;
  }

  return usdAmount;
}

export function convertDisplayToUsd(
  displayAmount: number,
  currency: CurrencyOption
): number {
  if (currency === CurrencyOption.CAD) {
    return displayAmount / USD_TO_CAD_EXCHANGE_RATE;
  }

  return displayAmount;
}

export function getCurrencySymbol(currency: CurrencyOption): string {
  if (currency === CurrencyOption.CAD) {
    return 'CA$';
  }

  return '$';
}

export function formatNumber(amount: number, maxFractionDigits = 0): string {
  const minFractionDigits = maxFractionDigits > 0 ? maxFractionDigits : 0;

  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: minFractionDigits,
    maximumFractionDigits: maxFractionDigits,
  }).format(Number.isFinite(amount) ? amount : 0);
}

export function formatAmountWithCurrency(
  amount: number,
  currency: CurrencyOption,
  maxFractionDigits = 0
): string {
  return `${getCurrencySymbol(currency)}${formatNumber(amount, maxFractionDigits)}`;
}

export function formatUsdAmount(amount: number, maxFractionDigits = 0) {
  return formatCurrency(amount, 'USD', maxFractionDigits);
}

export function perMileRate(value: number, distanceMiles: number): number {
  if (distanceMiles <= 0) {
    return 0;
  }

  return value / distanceMiles;
}

export type FormatAmountFn = (
  amount: number,
  maxFractionDigits?: number
) => string;

export function formatAmountRange(
  low: number,
  high: number,
  formatAmount: FormatAmountFn,
  maxFractionDigits = 0
): string {
  return `${formatAmount(low, maxFractionDigits)} - ${formatAmount(high, maxFractionDigits)}`;
}

export function formatAmountRangeWithSymbol(
  low: number,
  high: number,
  currency: CurrencyOption,
  maxFractionDigits = 0
): string {
  return `${getCurrencySymbol(currency)}${formatNumber(low, maxFractionDigits)} - ${formatNumber(high, maxFractionDigits)}`;
}

export function formatPerMileRateNumber(
  rate: number,
  maxFractionDigits = 2
): string {
  return formatNumber(rate, maxFractionDigits);
}

export function formatPerMileAmount(
  value: number,
  distanceMiles: number,
  formatAmount: FormatAmountFn
): string {
  return `${formatAmount(perMileRate(value, distanceMiles), 2)}/mi`;
}

export function formatPerMileAmountNumber(
  displayRate: number,
  maxFractionDigits = 2
): string {
  return `${formatNumber(displayRate, maxFractionDigits)}/mi`;
}

export function formatPerMileAmountRange(
  low: number,
  high: number,
  distanceMiles: number,
  formatAmount: FormatAmountFn
): string {
  return `${formatAmount(perMileRate(low, distanceMiles), 2)} - ${formatAmount(perMileRate(high, distanceMiles), 2)}/mi.`;
}

export function formatPerMileAmountRangeNumber(
  lowDisplayRate: number,
  highDisplayRate: number,
  maxFractionDigits = 2
): string {
  return `${formatNumber(lowDisplayRate, maxFractionDigits)} - ${formatNumber(highDisplayRate, maxFractionDigits)}/mi.`;
}
